import { render, staticRenderFns } from "./RenewVDDialog.vue?vue&type=template&id=482fd7e0&scoped=true"
import script from "./RenewVDDialog.vue?vue&type=script&lang=ts"
export * from "./RenewVDDialog.vue?vue&type=script&lang=ts"
import style0 from "./RenewVDDialog.vue?vue&type=style&index=0&id=482fd7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fd7e0",
  null
  
)

export default component.exports